import type { TradeUpFullInfo, TradeUpSelectedItem } from '~/components/Pages/TradeUp/types';
import type { ItemsByField } from '~/graphql/generated/schema-types';
import { defineStore } from 'pinia';

export const useTradeUpStore = defineStore('tradeUpStore', () => {
  // const selectedItems = ref([] as TradeUpSelectedItem[])
  const possibleItems = ref([] as TradeUpSelectedItem[]);
  const currentFullObject = ref<TradeUpFullInfo>({
    cost: 0,
    profit: 0,
    market_hash_name: '',
    updated_at: new Date().getTime(),
    items: [],
  } as TradeUpFullInfo);
  const selectedItems = computed({
    get: () => currentFullObject.value.items || [],
    set: (newItems: TradeUpSelectedItem[]) => {
      currentFullObject.value.items = newItems;
    },
  });

  const getPossibleItemsByItemsByField = (items: ItemsByField[]) => {
    return items.map(item => ({
      market_hash_name: item.market_hash_name || '',
      link: item.link || '',
      rarity_color: item.rarity_color || '',
      item_min_float: item.item_min_float || 0,
      item_max_float: item.item_max_float || 0,
      exterior: getExterior(item.market_hash_name) || '',
      volume: [],
      markets_info: [],
      locals: { localed_name: item.localed_name || '' },
      collection: item.collection || '',
      float: item.item_min_float || 0,
      rarity: item.rarity || '',
      is_stattrak: item.market_hash_name.toLowerCase().includes('stattrak'),
      percentage: 0,
    } as TradeUpSelectedItem));
  };

  const getVolumeObject = (item: TradeUpSelectedItem, link: string) => {
    link = getModifiedString(link);

    return item.volume?.find(volume => volume?.link === link)
      || item.volume?.[0] || null;
  };

  const calculates = computed(() => {
    let cost = 0;
    let totalFloats = 0;

    selectedItems.value.forEach((item) => {
      const volume = getVolumeObject(item, `${item.market_hash_name}-${getExteriorByFloat(item.float)}`);
      if (volume) {
        cost += volume.min_price || 0;
      }
      const float = item?.float > item?.item_max_float ? item?.item_max_float : item?.float < item?.item_min_float ? item?.item_min_float : item?.float;
      totalFloats += float;
    });

    let mostPossibleItem: TradeUpSelectedItem | undefined;
    let mostPossiblePrice = 0;
    possibleItems.value.forEach((item) => {
      if (!mostPossibleItem) {
        mostPossibleItem = item;
      }
      const itemPrice = item
        ? getVolumeObject(item, `${getItemNameWithCategory(item.market_hash_name)} ${getExteriorByFloat(item.float)}` || '')?.min_price || 0
        : 0;
      mostPossiblePrice += itemPrice;
      mostPossibleItem = (mostPossibleItem.percentage && mostPossibleItem.percentage > (item?.percentage || 0)
        ? mostPossibleItem
        : item) as TradeUpSelectedItem;
    });
    mostPossiblePrice = (mostPossiblePrice / possibleItems.value.length);

    return {
      cost,
      profit: mostPossiblePrice - cost,
      profitPercentage: (((mostPossiblePrice - cost) / cost * 100) || 0).toFixed(2),
      mostPossiblePrice,
      mostPossibleItem,
      avgFloat: (totalFloats / selectedItems.value.length || 0).toFixed(12),
    };
  });

  return {
    selectedItems,
    currentFullObject,
    possibleItems,
    calculates,

    getPossibleItemsByItemsByField,
    getVolumeObject,
  };
});
